import { render, staticRenderFns } from "./DictUpdatedLog.vue?vue&type=template&id=4cac0f16&scoped=true"
import script from "./DictUpdatedLog.vue?vue&type=script&lang=js"
export * from "./DictUpdatedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac0f16",
  null
  
)

export default component.exports